import classNames from 'classnames';
import styles from './index.module.sass'
import { Tooltip } from 'antd';

export var TableDataRow = ({
    active,
    topComp,
    bottomComp,
    fields,
    data,
    topCompRef,
    bottomCompRef,
  }: {
    active?: boolean;
    topComp?: boolean;
    topCompRef?: React.MutableRefObject<any>;
    bottomComp?: boolean;
    bottomCompRef?: React.MutableRefObject<any>;
    fields: { label: string; id: number; enabled: boolean; value: string }[];
    data: any; //IRustmixBuyerOffer;
  }) => (
    <ul className={classNames(styles.tableDataRow, active && styles.active)}>
      <li className={styles.tableCol}>
        {topComp && (
          <div className={styles.topCompWd} ref={topCompRef}>
            комп 1
          </div>
        )}
      </li>
      <li className={classNames(styles.tableCol, styles.markered, styles.nameField)}>
        <span>
          <Tooltip title={data.company_name}>{data.company_name}</Tooltip>
        </span>
      </li>
      <li className={classNames(styles.tableCol, styles.markered)}>
        {/* {data.class.split(',')[1]} */}{' '}
        {data.wheat_class ? (
          <span className={styles.noClass}>{data.wheat_class} класс</span>
        ) : (
          <span className={styles.noClass}>класс не определен</span>
        )}
        <span className={styles.noClass}>
          {data.price ? (
            <>
              <b>{Math.floor(data.price)?.toLocaleString('RU-ru')}</b> ₽/т
            </>
          ) : (
            'цена не задана'
          )}
        </span>
      </li>
      {fields.map((item, i) => {
        if (item.enabled)
          return (
            <li key={i} className={styles.tableCol}>
              {data[item.value] ? data[item.value] : 'н/д'}
            </li>
          );
      })}
      <li className={classNames(styles.tableCol, styles.markered)}>
        {/* {data.class.split(',')[1]} */}{' '}
        {data.wheat_class ? (
          <span className={styles.noClass}>{data.wheat_class} класс</span>
        ) : (
          <span className={styles.noClass}>класс не определен</span>
        )}
        <span className={styles.noClass}>
          {data.price ? (
            <>
              <b>{Math.floor(data.price)?.toLocaleString('RU-ru')}</b> ₽/т
            </>
          ) : (
            'цена не задана'
          )}
        </span>
      </li>
      <li className={classNames(styles.tableCol, styles.markered, styles.nameField)}>
        <span>
          <Tooltip title={data.company_name}>{data.company_name}</Tooltip>
        </span>
      </li>
      <li className={styles.tableCol}>
        {bottomComp && (
          <div className={styles.bottomCompWd} ref={bottomCompRef}>
            комп 2
          </div>
        )}
      </li>
    </ul>
  );